﻿import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export const Route = createFileRoute("/companies")({
  beforeLoad: ({ location }) => {
    const hasChildRoute = location.pathname.split("/").filter(Boolean).length > 1
    if (hasChildRoute) return
    const { isAuthenticated, user } = useAuthStore.getState()
    if (!isAuthenticated || user?.role !== "ADMIN") throw redirect({ to: "/login" })
  },
})
